import moment from 'moment'
import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function pickInitials(name: string) {
  const words = name.split(' ');
  if (words.length === 1) {
    return words[0][0];
  } else if (words.length === 2) {
    return words[0][0] + words[1][0];
  } else {
    return words[0][0] + words[words.length - 1][0];
  }
}

export function convertTo12HourFormat(timeString: string): string {
  if (!timeString) {
      return 'NA';
  }
  // Split the input time string by colon
  const [hour, minutes] = timeString.split(':');
  
  // Convert hour part to a number
  let hourNumber = parseInt(hour, 10);
  
  // Determine AM/PM suffix
  const suffix = hourNumber >= 12 ? 'PM' : 'AM';
  
  // Convert hour from 24-hour format to 12-hour format
  hourNumber = hourNumber % 12 || 12; // Adjust hour 0 to 12 for 12 AM and 12 PM
  
  // Return formatted time string
  return `${hourNumber}:${minutes} ${suffix}`;
}

export function timeAgo(input: string) {
  const now = moment();
  const inputTime = moment(input);
  const duration = moment.duration(now.diff(inputTime));

  let result;
  if (duration.asHours() < 1) {
    result = `Last used ${Math.floor(duration.asMinutes())} mins ago`;
  } else if (duration.asDays() < 1) {
    result = `Last used ${Math.floor(duration.asHours())} hrs ago`;
  } else {
    result = `Last used ${Math.floor(duration.asDays())} days ago`;
  }
  
  return result;
}

export function getElapsedTime(dateString: string) {
  // Parse the date string with moment.js
  const date = moment(dateString);

  // Get the current time
  const now = moment();

  // Calculate the duration between the given date and now
  const duration = moment.duration(now.diff(date));

  // Format the duration as hh:mm:ss
  const hours = String(Math.floor(duration.asHours())).padStart(2, '0');
  const minutes = String(duration.minutes()).padStart(2, '0');
  const seconds = String(duration.seconds()).padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
}
